import a3innuvaImage from './a3innuva.png'
import datevImage from './datev.png'
import genericImage from './generic.png'
import silaeImage from './silae.png'

export const getUpsellImage = (integrationSlug: string) => {
  const slug = integrationSlug.toLowerCase()
  switch (slug) {
    case 'a3innuva':
      return a3innuvaImage
    case 'silae-fortify':
      return silaeImage
    case 'datev-lauds':
      return datevImage
    default:
      return genericImage
  }
}
